/************************************************************
 Workflow Namespace
 ************************************************************/

window.workflow = {
    _action:null,
    _callback:null,
    _row:null,
    // Execute Action
    executeAction:function (action, callback, row) {
        this._action = action;
        this._callback = callback;
        this._row = row;

        var params = {
            task_id:action.task_id,
            wf_id:action.wf_id,
            wf_status_id:action.to_state_id,
            wf_action_id:action.wf_action_id};


        if(parseInt(action.wf_action_id) == globalConstants.ACTION_VIEW_TASK_DETAILS_CLOSE_MODAL){
            $.get('/workflow/view_task_details', params, null, "html")
                .done(function (data, status, xhr) {
                    Hades.checkIfUserIsAuthorized(data, status, xhr);

                    $.fancybox({content:data, autoScale:true, autoDimensions:true});

                    Hades.hideLoading();
                })
                .fail(function (xhr, status, error) {
                    Hades.showError(error, xhr.responseText, xhr, status, error);
                    Hades.hideLoading();
                    workflow._callback(false, workflow._action, workflow._row);
                });
        }
        else if ((action.wf_action_id == globalConstants.ACTION_UNDO_START_EPISODE) || (action.wf_action_id == globalConstants.ACTION_UNDO_FINALIZE_EPISODE && action.wf_id != globalConstants.WF_EPISODE_MCDT) || (action.wf_action_id == 110)  || (action.wf_action_id == 109)) {
            episode.executeAction(action, row, callback);
        } else if (action.wf_id == globalConstants.WF_EPISODE && ((action.wf_action_id == 17) || /*KHIS-4206*/ action.wf_action_id == 74 || action.wf_action_id == 2  ) ){
            episode.executeAction(action, row, callback);
        } else if (action.wf_id == globalConstants.WF_REQUISITION_ORDER) {
            physiotherapyRequisitionOrder.executeAction(action, row, callback);
        } else if (action.wf_id == globalConstants.WF_PHYSIOTHERAPY_PRESCRIPTION) {
            physiotherapyPrescriptionNS.executeAction(action, row, callback);
        } else if (action.wf_id == globalConstants.WF_APPOINTMENT ) {
            appointmentNS.executeAction(action, row, callback);
        }else if (action.wf_id == globalConstants.WF_EXTERIOR_PRESCRIPTION) {
            exteriorPrescriptionNS.executeAction(action, row, callback);
        }else if (action.wf_id == globalConstants.WF_EXTERIOR_PRESCRIPTION_GROUP) {
            exteriorPrescriptionGroupNS.executeAction(action, row, callback);
        }else if (action.wf_id == globalConstants.WF_DENTAL_MEDICINE_MEDICAL_ACT) {
            dentalMedicineMedicalActNS.executeAction(action, row, callback);
        }else if (action.wf_id == globalConstants.WF_OCCUPATIONAL_MEDICINE_EPISODE || action.wf_id == globalConstants.WF_OCCUPATIONAL_MEDICINE_APPOINTMENT) {
            occupationalMedicineNS.executeAction(action, row, callback);
        } else if (action.wf_id == globalConstants.WF_CONSULT_PROCESS) {
            consultProcessNS.executeAction(action, row, callback);
        } else if ( action.wf_id == globalConstants.WF_SMAP_CONSULT &&  action.wf_action_id == globalConstants.ACTION_FINALIZED_CONSULT_SMAP ){
            episode.executeAction(action, row, callback);
        //} else if (action.wf_id == globalConstants.WF_EPISODE && action.wf_action_id == 125 ){
            //episode.executeAction(action, row, callback);
        //}else if (action.wf_id == globalConstants.WF_EPISODE && action.wf_action_id == 127 ) {
            //episode.executeAction(action, row, callback);
        } else if (action.wf_id == globalConstants.WF_EPISODE_MCDT) {
            mcdtNS.executeAction(action, row, callback);
        } else if (action.wf_id == globalConstants.WF_MCDT) {
            mcdtProcessNS.executeAction(action, row, callback);
        } else if (action.wf_id == globalConstants.WF_HCP_PORTAL) {
            healthCarePlanNS.executeAction(action, row, callback);
        } else if (action.wf_id == globalConstants.WF_HCP_PROCEDURES) {
            healthCarePlanNS.executeAction(action, row, callback);
        } else if (action.wf_id == globalConstants.WF_HCP_REIMBURSEMENT_MANAGEMENT_REQUEST_PROCESS) {
            healthCarePlanNS.executeAction(action, row, callback);
        } else if (action.wf_id == globalConstants.WF_HCP_REIMBURSEMENT_MANAGEMENT_PROCEDURES) {
            healthCarePlanNS.executeAction(action, row, callback);
        } else {

            $.getJSON('/workflow/execute_action', params)
                .done(function (data, status, xhr) {
                    Hades.checkIfUserIsAuthorized(data, status, xhr);

                    if (data.success) {
                        workflow._callback(true, workflow._action, workflow._row);
                    } else {
                        //Hades.showError(Hades.workflowErrorMsg(), data.error, xhr, status, data.error);
                        bootbox.alert(data.error);

                        Hades.hideLoading();

                        workflow._callback(false, workflow._action, workflow._row);
                    }
                })
                .fail(function (xhr, status, error) {
                    Hades.showError(error, xhr.responseText, xhr, status, error);
                    Hades.hideLoading();

                    workflow._callback(false, workflow._action, workflow._row);
                });
        }
    },

    executeGenericAction: function(action, callback, row) {

        var _action = action;        
        _action.episode_admission_type_id = null;

        if ( ( action.wf_id == 1 && action.from_state_id == 1 && action.to_state_id == 5 ) || ( action.wf_id == 25 && action.wf_action_id == 1 ) ) {
            Hades.showLoading();

            $.getJSON('/workflow/get_admission_url', action)
                .done(function (data, status, xhr) {
                    Hades.checkIfUserIsAuthorized(data, status, xhr);
                    var _data = data;

                    if (data.adse_validate_beneficiary_acts && data.wf_id != 25 /* process inpatient */){

                        $.getJSON('/workflow/validate_adse_beneficiary_acts', {data: data, admission_info: data.admission_info, task_id: data.task_id, wf_id: data.wf_id})
                            .done(function (data, status, xhr) {
                                if (data.success){
                                    if (data.success.data && data.success.data.valid == true){
                                        if (_data.admission_by_card){
                                            workflow.validate_citzen_card(_data, action, callback, row);
                                        }else{
                                            workflow.doExecuteGenericAction(_action, callback, row);
                                        }
                                    }else if (data.success.data && data.success.data.valid == false){
                                        var msg_validate_adse_elegibility_false = GlobalTranslations['APP_LABEL.2992'];
                                        bootbox.alert(msg_validate_adse_elegibility_false);
                                    }
                                    else {
                                        var validate_adse_benf_acts_error_msg = GlobalTranslations['APP_LABEL.2991'];
                                        bootbox.alert(validate_adse_benf_acts_error_msg);
                                    }
                                }else{
                                    var validate_adse_benf_acts_error_msg = GlobalTranslations['APP_LABEL.2991'];
                                    bootbox.alert(validate_adse_benf_acts_error_msg);
                                }

                            })
                            .fail(function (xhr, status, error) {
                                Hades.showError(error, xhr.responseText, xhr, status, error);
                                workflow.doExecuteGenericAction(action, callback, row);
                            });

                    }else{
                        if (data.admission_by_card){
                            workflow.validate_citzen_card(data, action, callback, row);
                        }else{
                            workflow.doExecuteGenericAction(_action, callback, row);
                        }
                    }


                })
                .fail(function (xhr, status, error) {
                    Hades.showError(error, xhr.responseText, xhr, status, error);
                    workflow.doExecuteGenericAction(action, callback, row);
                });

        } else { // wf is not patient_arrival, proceed normally
            workflow.doExecuteGenericAction(action, callback, row);
        }
    },


    validate_citzen_card: function(data, action, callback, row){

        var _action = action;
        _action.episode_admission_type_id = null;

        if (data.admission_by_card) {
            Hades.showLoading();
            var params = { message: '' };
            var url_path = data.citizen_card_url;

            var admission_info = data.admission_info;

            $.ajax({
                url: url_path,
                type: 'POST',
                crossDomain: true,
                contentType: 'application/x-www-form-urlencoded; charset=utf-8',
                data: $.param(params),
                success: function (data, status, xhr) {
                    Hades.checkIfUserIsAuthorized(data, status, xhr);
                    if (data.status == "success") {
                        var citizen = $.parseJSON(data.data.message);
                        //debug.log('Citizen:', citizen, admission_info);
                        if (admission_info && admission_info.patient_fiscal_number == citizen.taxNumber) {
                            _action.episode_admission_type_id = 1;
                        } else {
                            var auth_cc_error_msg = GlobalTranslations['APP_LABEL.2532'];
                            bootbox.alert(auth_cc_error_msg);
                        }
                    } else {
                        var auth_cc_error_msg = GlobalTranslations['APP_LABEL.2169'];
                        bootbox.alert(auth_cc_error_msg);
                    }

                    workflow.doExecuteGenericAction(_action, callback, row);
                },
                error: function (xhr, status, error) {
                    var enpoint_communication_error = GlobalTranslations['APP_LABEL.2388'];
                    bootbox.alert(enpoint_communication_error);

                    workflow.doExecuteGenericAction(_action, callback, row);
                }
            });

        } else { // sys config is inactive or client_setting is not defined
            workflow.doExecuteGenericAction(action, callback, row);
        }

    },

    doExecuteGenericAction: function (action, callback, row) {

        this._action = action;
        this._callback = callback;
        this._row = row;
        var _wf_status_id = action.from_state_id;

        if (action.wf_id == 25 /*Inpatient*/){
            _wf_status_id = action.to_state_id;
        }

        var params = {
            task_id:action.task_id,
            wf_id:action.wf_id,
            wf_status_id: _wf_status_id,
            wf_action_id: action.wf_action_id,
            appointment_type_id: row == null ? row : row.appointment_type_id,
            episode_admission_type_id: action.episode_admission_type_id,
            finalized_date: action.finalized_modal == undefined ? '' : action.finalized_modal.date,
            finalized_hour: action.finalized_modal == undefined ? '' : action.finalized_modal.hour
        };

        $.getJSON('/workflow/execute_action', params)
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success) {
                    callback(true, action, row);
                } else {
                    //Hades.showError(Hades.workflowErrorMsg(), data.error, xhr, status, data.error);
                    bootbox.alert(data.error);

                    Hades.hideLoading();

                    callback(false, action, row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();

                callback(false, action, row);
            });            
    },

    openGenericReasonModal: function (callback) {
        var params = {
            task_id: workflow._action.task_id,
            wf_id: workflow._action.wf_id,
            wf_status_id: workflow._action.from_state_id,
            wf_from_state_id: workflow._action.from_state_id,
            wf_to_state_id: workflow._action.to_state_id,
            wf_action_id: workflow._action.wf_action_id
        };

        $.get('/modal/generic_reason_window', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                if (callback) {
                    $('#generic-reason-modal-ct').bind('genericReasonConfirmed', callback);
                }else{
                    $('#generic-reason-modal-ct').bind('genericReasonConfirmed', workflow.executeGenericActionWithReason);
                }

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                workflow._callback(false, workflow._action, workflow._row);
            });
    },
    executeGenericActionWithReason:function (event, data) {
        $.fancybox.close(true);

        var params = {
            task_id: workflow._action.task_id,
            wf_id: workflow._action.wf_id,
            wf_status_id: workflow._action.from_state_id,
            wf_action_id: workflow._action.wf_action_id,

            reason_id: data.reasonId,
            other_reason: data.otherReason,
            date: data.date,
            hour: data.hour
        };

        $.getJSON('/workflow/execute_generic_action_with_reason', params)
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    workflow._callback(false, workflow._action, workflow._row);
                } else {
                    workflow._callback(true, workflow._action, workflow._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                workflow._callback(false, workflow._action, workflow._row);
            });
    }
};